"use strict";
import ManagerBookingsRep from 'emun.salesrep/manager-bookings-rep';

function custom(mod) {
  mod.component('managerBookingsRep', ManagerBookingsRep);
}

export default custom;